import styled from 'styled-components';
import { Spinner } from 'ui/spinner';
import { colors, spacing } from 'ui/theme';
import { LOADING_CAMPAIGN_SPINNER } from '../constants';

const StyledSpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${colors.grey50};
`;

const StyledSpinner = styled(Spinner)`
  margin: ${spacing.half};
`;

export const LoadingCampaignsSpinner = () => {
  return (
    <StyledSpinnerContainer>
      <StyledSpinner data-test={LOADING_CAMPAIGN_SPINNER} size={36} />
      <span>Loading campaigns....</span>
    </StyledSpinnerContainer>
  );
};
